import { EnvironmentInjector, Injectable, NgZone, inject, runInInjectionContext } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  private injector = inject(EnvironmentInjector);

  constructor(
    private firebaseAuth: Auth,
    private router: Router,
    private ngZone: NgZone
  ) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return new Promise((resolve) => {
      runInInjectionContext(this.injector, () => {
        onAuthStateChanged(this.firebaseAuth, (user) => {
          const isLoggedIn = !!user
          if (!isLoggedIn) this.ngZone.run(() => this.router.navigate(['/', 'login']))
          resolve(isLoggedIn)
        })
      })
    })
  }
}
